/** Must match server `constants/upiPaymentApps.js` */
export const UPI_PAYMENT_APP_OPTIONS = [
  "PhonePe",
  "Google Pay",
  "Paytm",
  "Bhim",
  "Other",
];

export const UPI_UTR_REGEX = /^\d{12}$/;
